export interface WorkspaceSelectionLocation {
  pathname: string;
  search: string;
  hash: string;
}

export type WorkspaceActiveView =
  | { type: "overview" }
  | { type: "workspace"; id: string };

const OVERVIEW_VIEW = "overview";

export const readActiveView = (
  search: string,
  workspaceIds: ReadonlyArray<string>,
): WorkspaceActiveView => {
  const params = new URLSearchParams(search);
  // Explicit view=overview takes priority over any workspace param.
  if (params.get("view") === OVERVIEW_VIEW) {
    return { type: "overview" };
  }
  const workspaceId = params.get("workspace");
  if (workspaceId && workspaceIds.includes(workspaceId)) {
    return { type: "workspace", id: workspaceId };
  }
  return { type: "overview" };
};

export const buildOverviewUrl = (
  location: WorkspaceSelectionLocation,
): string => {
  const search = new URLSearchParams(location.search);
  search.delete("workspace");
  search.set("view", OVERVIEW_VIEW);
  const query = search.toString();
  return `${location.pathname}${query ? `?${query}` : ""}${location.hash}`;
};

export const buildWorkspaceSelectionUrl = (
  location: WorkspaceSelectionLocation,
  workspaceId: string,
): string => {
  const search = new URLSearchParams(location.search);
  search.delete("view");
  search.set("workspace", workspaceId);
  const query = search.toString();
  return `${location.pathname}${query ? `?${query}` : ""}${location.hash}`;
};
